// src/contexts/UserContext.js
import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const UserContext  = createContext(null);



export const UserProvider = ({ children }) => {
  const [userId, setUserId] = useState(null);
  const [clientContext, setClientContext] = useState([]);
  const [contractsContext, setContractsContext] = useState({});
  const [projectsContext, setProjectsContext] = useState({});
  const [cirContext, setCirContext] = useState({});


  useEffect(() => {
  // setUserId('krishna.uppalapati@accenture.com');
  // setUserId('priyadarshini.a.ravi@accenture.com');
  // setUserId('sarfaraz.rahim@accenture.com');
  //  setUserId('sridevi.arun.k@accenture.com');
   // setUserId('uma.m.alladi@accenture.com');
  //  setUserId('shoba.tholasiram@accenture.com');
 //  setUserId('kowsalya.ramasamy@accenture.com');
 //   setUserId('kavitha.krishnappa@accenture.com');
 //  setUserId('bhaskarani.s.sandeep@accenture.com');  
    axios.get('/api/getloggedinuserdetails')
    .then((res) => {
      if (res.data.userId) {
        setUserId(res.data.userId+'@accenture.com');
      }
    })
    .catch((err) => {
      console.error('Failed to fetch user ID:', err);
    });
  }, []);

  return (
    <UserContext.Provider value={{ userId,clientContext,
      setClientContext,
      contractsContext,
      setContractsContext,
      projectsContext,
      setProjectsContext,cirContext, setCirContext }}>
      {children}
    </UserContext.Provider>
  );
};
